import { render, staticRenderFns } from "./MainPageTable.vue?vue&type=template&id=3344a6a0&"
import script from "./MainPageTable.vue?vue&type=script&lang=js&"
export * from "./MainPageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports